export enum LogbookEntrySortOrder {
    Date,
    Group,
    Severity,
    LastModificationDate
}